module.exports = __webpack_public_path__ + "2a782fc94cd02920b357b63c05fff027.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileApp/play-store.png
// module id = 1334
// module chunks = 47